export function Table({
  columns,
  data,
  keyField = 'id',
  className = '',
  footerRows = [],
}) {
  return (
    <div style={{overflowX:'auto'}}>
      <table className={`table ${className}`.trim()}>
        <thead>
          <tr>
            {columns.map(c => <th key={c.key} style={c.thStyle} className={c.className}>{c.header}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map(row => <tr key={row[keyField] || JSON.stringify(row)}>
            {columns.map(c => <td key={c.key} style={c.tdStyle} className={c.className}>{c.render ? c.render(row[c.key], row) : row[c.key]}</td>)}
          </tr>)}
          {data.length === 0 && <tr><td colSpan={columns.length} style={{textAlign:'center', fontSize:'.75rem', padding:'1rem'}}>Nenhum registro</td></tr>}
        </tbody>
        {footerRows.length > 0 && (
          <tfoot>
            {footerRows.map((row, index) => (
              <tr key={row.key || index}>
                <td colSpan={Math.max(1, columns.length - 1)} style={{fontWeight:600}}>
                  {row.label}
                </td>
                <td style={{textAlign:'right', fontWeight:700, ...(row.valueStyle || {})}}>{row.value}</td>
              </tr>
            ))}
          </tfoot>
        )}
      </table>
    </div>
  );
}
